module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.19798/images/no-results.svg"